module.exports = __webpack_public_path__ + "491bb46ff9ba8c68e284b0c4d94c9347.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/age-gate-bg-1080.jpg
// module id = 164
// module chunks = 0